import { FilterProductEnum, currentFlightFilterSelectionsVar, currentHotelFilterSelectionsVar } from '@honeycomb/data';
// Determine the total number of filters currently applied.
export const useAppliedFiltersCount = (product) => {
    const appliedFilters = product === FilterProductEnum.FLIGHT ? currentFlightFilterSelectionsVar() : currentHotelFilterSelectionsVar();
    const appliedFiltersCount = Object.keys(appliedFilters).reduce((acc, filterType) => {
        var _a;
        if (filterType === 'checkboxFilters') {
            const filters = appliedFilters.checkboxFilters;
            return (acc +
                (filters
                    ? filters.reduce((acc2, value) => {
                        return acc2 + value.selectedIds.length;
                    }, 0)
                    : 0));
        }
        if (filterType === 'rangeFilters') {
            return acc + (((_a = appliedFilters.rangeFilters) === null || _a === void 0 ? void 0 : _a.length) || 0);
        }
        if (filterType === 'textFilter') {
            // For hotels, a text filters is incuded in the object even when it's value is null.
            // This seems like a bug. For consitency the property should be removed when it has no value.
            const filters = appliedFilters.textFilter;
            return (acc +
                (filters
                    ? filters.reduce((acc2, value) => {
                        return acc2 + (value.value ? 1 : 0);
                    }, 0)
                    : 0));
        }
        return 0;
    }, 0);
    return appliedFiltersCount;
};
